// extracted by mini-css-extract-plugin
export default {"title":"gba-z","warning":"hba-z","sizeOptionsLegendText":"iba-z"};